import { Routes, Route } from "react-router-dom";

// Pages
import CLI from "../pages/CLI";
import Library from "../pages/Library";
import GettingStarted from "../pages/GettingStarted";

// Documentations
import CrudDoc from "@/pages/library-docs/CrudDoc";
import DomainDoc from "@/pages/library-docs/DomainDoc";
import CommonDoc from "@/pages/library-docs/CommonDoc";
import ServiceDoc from "@/pages/library-docs/ServiceDoc";
import BehaviorDoc from "@/pages/library-docs/BehaviorDoc";
import AttributeDoc from "@/pages/library-docs/AttributeDoc";
import RepositoryDoc from "@/pages/library-docs/RepositoryDoc";
import BaseEntityDoc from "@/pages/library-docs/BaseEntityDoc";
import MiddlewareDoc from "@/pages/library-docs/MiddlewareDoc";
import ExtensionsDoc from "@/pages/library-docs/ExtensionsDoc";
import PresentationDoc from "@/pages/library-docs/PresentationDoc";

// Documentations
import CLIInfoDoc from "@/pages/cli-docs/InfoDoc";
import CLITestDoc from "@/pages/cli-docs/TestDoc";
import CLIHelpDoc from "@/pages/cli-docs/HelpDoc";
import CLIFlagDoc from "@/pages/cli-docs/FlagsDoc";
import CLIReadyDoc from "@/pages/cli-docs/ReadyDoc";
import CLIDomainDoc from "@/pages/cli-docs/DomainDoc";
import CLIFeatureDoc from "@/pages/cli-docs/FeatureDoc";
import CLIServiceDoc from "@/pages/cli-docs/ServiceDoc";
import CLIRepositoryDoc from "@/pages/cli-docs/RepositoryDoc";
import CLIControllerDoc from "@/pages/cli-docs/ControllerDoc";

const DocRoutes = () => {
  return (
    <Routes>
      {/* GETTING ROUTES */}
      <Route path="/getting-started" element={<GettingStarted />} />

      {/* LIBRARY ROUTES */}
      <Route path="/library" element={<Library />} />
      <Route path="/library/crud" element={<CrudDoc />} />
      <Route path="/library/domains" element={<DomainDoc />} />
      <Route path="/library/commons" element={<CommonDoc />} />
      <Route path="/library/services" element={<ServiceDoc />} />
      <Route path="/library/behaviors" element={<BehaviorDoc />} />
      <Route path="/library/attributes" element={<AttributeDoc />} />
      <Route path="/library/extensions" element={<ExtensionsDoc />} />
      <Route path="/library/middlewares" element={<MiddlewareDoc />} />
      <Route path="/library/repositories" element={<RepositoryDoc />} />
      <Route path="/library/base-entities" element={<BaseEntityDoc />} />
      <Route path="/library/presentations" element={<PresentationDoc />} />

      {/* CLI ROUTES */}
      <Route path="/cli" element={<CLI />} />
      <Route path="/ready" element={<CLIReadyDoc />} />
      <Route path="/cli/add-test" element={<CLITestDoc />} />
      <Route path="/cli/add-domain" element={<CLIDomainDoc />} />
      <Route path="/cli/add-feature" element={<CLIFeatureDoc />} />
      <Route path="/cli/add-service" element={<CLIServiceDoc />} />
      <Route path="/cli/add-controller" element={<CLIControllerDoc />} />
      <Route path="/cli/add-repository" element={<CLIRepositoryDoc />} />
      <Route path="/cli/help" element={<CLIHelpDoc />} />
      <Route path="/cli/info" element={<CLIInfoDoc />} />
      <Route path="/cli/flags" element={<CLIFlagDoc />} />
    </Routes>
  );
};

export default DocRoutes;
